import {FormikValues} from 'formik';

import {FilterState} from '@/components/features/search/filters/FiltersUtils/types';

type ShouldUpdateFiltersOptions = {
  includeGroupOrdering?: boolean;
  includePackaging?: boolean;
};

export const shouldUpdateFilters = (
  values: FormikValues,
  filters: FilterState,
  {includeGroupOrdering = true, includePackaging = true}: ShouldUpdateFiltersOptions = {},
) => {
  const updatedFilters = {
    budgetAmount: values.budgetAmount,
    businessSizingTaxonomy: values.smallBusiness ? 'SMALL_BUSINESS' : '',
    distance: values.distance,
    ...(includePackaging && {individualPackaging: values.packaging ? 'true' : ''}),
    orderMinimum: values.orderMinimum,
    ...(includeGroupOrdering && {
      serviceCapabilitiesTaxonomy: values.groupOrdering ? 'GROUP_ORDERING' : '',
    }),
    suitabilityTaxonomy: values.newRestaurants ? 'NEW_BUSINESS' : '',
  };

  // This looks scary because of TypeScript but it's just a way to compare the updated filters with the current filters
  const shouldUpdate = (Object.keys(updatedFilters) as (keyof typeof updatedFilters)[]).some(
    key => updatedFilters[key] !== filters[key],
  );

  return [shouldUpdate, updatedFilters] as const;
};

export const stringArraysAreEqual = (array1: string[], array2: string[]) => {
  if (array1.length !== array2.length) return false;
  const sortedArray1 = [...array1].sort();
  const sortedArray2 = [...array2].sort();
  return sortedArray1.every((value, index) => value === sortedArray2[index]);
};
